module.exports = __webpack_public_path__ + "img/fileA.88919d3c.png";